import { Injectable, Output, EventEmitter } from '@angular/core';
import {JsonApiService} from "../../core/services/json-api.service";
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';


import * as firebase from "firebase/app";
import { AuthService } from './auth.service';
import { AppService } from './app.service';


@Injectable()
export class ChatService {

  url: string;
  user:any;

  users:any = [];

  public messageToSubject;
  public newMessage;

  constructor(private jsonApiService: JsonApiService, 
        private afs: AngularFirestore,
        public auth: AuthService,
        public app: AppService) {
    this.url = '/chat/chat.json';
    this.messageToSubject = new Subject();
    this.newMessage = new Subject();
    this.init();
  }

  async init(){
    this.user = await this.auth.getCurrentUser();
  }


  getChatState()  {
    return this.jsonApiService.fetch(this.url)

  }

  messageTo(user){
    this.messageToSubject.next(user)
  }

  sendMessage(message){
    this.newMessage.next(message)

  }


  getDealers() {
    let dealers = this.afs
    .collection("dealers", ref => ref.where("active", "==", true)
                                     .orderBy("online", "desc")
                                     .orderBy("code", "asc")).valueChanges();
    return dealers;
  } 


  getRooms(){
    return this.afs.firestore
    .collection("chats").orderBy("createdAt", "desc"); 
  } 

  getRoomMessages(uidOrder: string) {
    return this.afs
    .collection("chats")
    .doc(uidOrder).collection("messages", ref => ref.orderBy("date", "asc"))
    .valueChanges();
  } //end getRoomMessages

  getRoomMessagesChanges(uidOrder: string){
    return this.afs.firestore
    .collection("chats")
    .doc(uidOrder).collection("messages").orderBy("date", "asc");
  } //end getRoomMessages


  getListRoomMActives(uidUser: string) {
    const filtro = `users.${uidUser}`;
    //return this.afs
    //  .collection("chats", ref => ref.where(filtro, "==", true).orderBy('updatedAt', 'desc'));
    return this.afs
      .collection("chats", ref => ref.orderBy(`users.${uidUser}`).limit(5)).valueChanges();
  } //end getRoomMessages


  async setRoomMessage5(chatId: string, user:any, text: any, isNew: boolean) {


    let now = firebase.firestore.FieldValue.serverTimestamp();

    let message = {
      text: text,
      uidUser: user.uid,
      date: now,
      uid: this.afs.createId()
    };

    if(isNew){
      await this.afs
          .doc("chats/"+chatId)
          .set({
            title: 'Pedido #',
            createdAt: now,
            uid: chatId
          }, {merge:true});
    }

    const users:{[k: string]: any} = {};
    
    users[message.uidUser] = true;
      
    await this.afs
      .doc("chats/"+chatId)
      .set({
        //messages: firestore.FieldValue.arrayUnion(message),
        users,
        updatedAt: now
      }, {merge:true}); 

    await this.afs.doc("chats/"+chatId).collection("messages").doc(message.uid).set(message);
  } //end setRoomMessage

  async setRoomMessage(chatId: string, user:any ,msg: any, isNew: boolean, counter:number, type='user') {
    const time = firebase.firestore.Timestamp.now().toDate();

    if(counter==0){
      await this.afs
          .doc("chats/"+chatId)
          .set({
            title: 'Chat con #BASE',
            createdAt: time,
            uid: chatId,
            type,
            active: true
          }, {merge:true});
    }

    const users:{[k: string]: any} = {};

    if(type=='order'){
      let order:any = await this.app.getOrderById(chatId);
      if(order.client!==undefined && order.client !== null){
        if(order.client.uid!=='' || order.client.uid!==null )
          users[order.client.uid] = true;
      }
      if(order.dealer!==undefined && order.dealer !== null){
        if(order.dealer.uid!=='' || order.dealer.uid!==null )
          users['m-'+order.dealer.uid] = true;
      }
    }else{
      users['m-'+user.userUid] = true;
    }

    users["b-" + this.user.uid] = true;

    const reads:{[k: string]: any} = {};
    reads['b-' + this.user.uid] = counter + 1;

    let message = {
      text: msg,
      uidUser: 'b-'+this.user.uid,
      date: time,
      type: 'base',
      uid: this.afs.createId() 
    };

      
    await this.afs
      .doc("chats/"+chatId)
      .set({
        //messages: firestore.FieldValue.arrayUnion(message),
        lastMessage: msg,
        users,
        reads,
        length: counter + 1,
        updatedAt: time
      }, {merge:true});

      await this.afs.doc("chats/"+chatId).collection("messages").doc(message.uid).set(message);
  } //end setRoomMessage

  async updateReadsMessage(uidOrder: string, uidUser: string, length:number) {

    const reads:{[k: string]: any} = {};
    reads['b-'+uidUser] = length;
      
    await this.afs
      .doc("chats/"+uidOrder)
      .set({
        reads,
        length
      }, {merge:true});
  } //end setRoomMessage


  private messageSource = new BehaviorSubject(null);
  currentMessage = this.messageSource.asObservable();

  changeMessage(order: any) {
    this.messageSource.next(order);
  }
}
